import React, {useState, useEffect} from "react";
import {isEcommerceEnabled, isOrderBeforeMessageEnabled} from "../../../../selectors/generic";
import {useI18N} from "../../../my-puratos/hoc/withI18N";
import {getOrderBefore} from "../../../../api/ECOM/getOrderBefore.api";
import {GetOrderBeforeResponse} from "../../../../interfaces/ecom/schema";
import {getMoment} from "../../../../utils/momentUtils";
import {useSelector} from "react-redux";

export const DeliveryBanner = () => {
    const isDeliveryBannerEnabled = useSelector(isOrderBeforeMessageEnabled);

    if (!isEcommerceEnabled() || !isDeliveryBannerEnabled) {
        return null;
    }

    const translate = useI18N();

    const [data, setData] = React.useState<GetOrderBeforeResponse>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const isDateProvided = !!(data?.OrderBeforeDate || data?.OrderBeforeTime) && !data?.TodaysCutoffIsAlreadyInThePast;
    const isMinimumProvided = !!data?.OrderMin?.CurrencyValue || !!data?.OrderMin?.WeightValue;
    const showBanner = !(isLoading || isError ) && (isDateProvided || isMinimumProvided);
    const moment = getMoment();

    const messages = [
        !!(data?.OrderBeforeTime || data?.DeliveryDate) && translate('Please order before {1} to receive your order on {2}', [],[`<strong>${data.OrderBeforeTime.slice(0, -3)}</strong>`], [`<strong>${moment(data.DeliveryDate, 'YYYY-MM-DD').format('dddd')}</strong>`]),
        !!(data?.OrderMin?.CurrencyValue) && translate('Minimum order value is {0}', [`<strong>${data.OrderMin.CurrencyValue}</strong>`]),
        !!(data?.OrderMin?.WeightValue) && translate('Minimum order weight is {0}', [`<strong>${data.OrderMin.WeightValue}</strong>`])
    ].filter(message => !!message);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [messages.length]);

    useEffect(() => {
        (async () => {
            try {
                const response = await getOrderBefore();
                setData(response);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsError(true);
            }
        })();
    }, []);


    if (!showBanner) {
        return null;
    }

    return (
        <div className={'delivery-banner'}>
            <div className={'delivery-banner__container'}>
                {messages.map((message,index) =>
                        <span key={index} dangerouslySetInnerHTML={{__html: message}} className={`delivery-banner__text ${index === currentIndex ? 'active' : ''}`}/>
                )}
            </div>
        </div>
    )
}
